/**
 * `marked-base-url` calls `URL.canParse` while `main.ts` sets up markdown, before Angular bootstraps.
 * Safari before 17 and Chrome before 120 lack it, so without this shim the app never starts there.
 */
export function canParseUrl(url: string | URL, base?: string | URL): boolean {
  try {
    new URL(url, base);
    return true;
  } catch {
    return false;
  }
}

export function installUrlCanParse(target: Partial<Pick<typeof URL, 'canParse'>> = URL): void {
  if (typeof target.canParse !== 'function') {
    target.canParse = canParseUrl;
  }
}

installUrlCanParse();
